import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  AddressInfoDto,
  BackResponse,
  BackResponseFailure,
  PickupPointAddress,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface SetClaimGroupHandlingCommandArgs {
  claimGroupId: string;
  handlingMode: string;
  pickupPointId: string;
  pickupPointAddress: PickupPointAddress;
  carrierPriceId: {
    carrierSellerPriceId: string;
    carrierCustomerPriceId: string;
  };
  address: AddressInfoDto;
}

export const setClaimGroupHandlingRequest = ({
  claimGroupId,
  handlingMode,
  pickupPointId,
  pickupPointAddress,
  carrierPriceId,
  address,
}: SetClaimGroupHandlingCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/handling`,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: {
      handlingMode,
      ...carrierPriceId,
      address,
      pickupPointId,
      pickupPointAddress,
    },
  },
});

export const setClaimGroupHandlingCommand = async (
  args: SetClaimGroupHandlingCommandArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      setClaimGroupHandlingRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
